// @flow

import Resource from 'speed-js-core/src/api/Resource';

export default class PricingPlanResource extends Resource {
    basePath: string = 'billing/pricing-plan/';

    objectPath: string = 'billing/pricing-plan/{ident}/';
}
